module.exports = __webpack_public_path__ + "img/borders5.6d95621e.png";